import React, { useState } from "react";
import { TextField, Button, Alert, CircularProgress } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import "./PasswordOtpVerificationForm.css"; // Reuse the RegistrationForm CSS for consistency
import WhiteInputField from '../../common/StyledComponents/WhiteInputField/WhiteInputField';

const PasswordOtpVerificationForm = ({ setCurrentStep }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const axiosInstance = useAxios();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Enable loading state

    try {
      const response = await axiosInstance.post("/reset-password", { otp });
      console.log(response.data);
      localStorage.setItem("token", response.data.token);
      setCurrentStep("login"); // Proceed to login form
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Invalid or expired OTP.");
    } finally {
      setLoading(false); // Disable loading state
    }
  };

  const handleResendOtp = async () => {
    setError(null);
    try {
      await axiosInstance.post("/resend-otp");
      alert("A new OTP has been sent to your email.");
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP. Please try again.");
    }
  };

  return (
    <form className="otp-verification-form" onSubmit={handleSubmit}>
      <h2 className="form-title">Verify OTP</h2>
      {error && <Alert severity="error">{error}</Alert>}
      <WhiteInputField
        className="custom-text-field"
        label="Enter OTP"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        required
      />
      <Button
        type="submit"
        className="submit-button primary-button"
        disabled={loading} // Disable button during loading
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Verify"}
      </Button>
      <Button 
        onClick={handleResendOtp} 
        // onClick={() => {}} 
        className="white-text-button">
        Resend OTP
      </Button>
    </form>
  );
};

export default PasswordOtpVerificationForm;
